
var archiveAnnouncementsTable;
var archiveNotificationsTable;

function CreateArchiveTables() {
    $(document).ready(function () {
    var tableHeight = window.innerHeight - 64 - 256;

    if (tableHeight < 256) {
        tableHeight = 256;
    }

    archiveAnnouncementsTable = jexcel(document.getElementById('expiredannouncementsgrid'), {
        allowManualInsertColumn: false,
        allowInsertColumn: false,
        allowDeleteColumn: false,
        allowRenameColumn: false,
        columnDrag: false,
        data: null,
        tableWidth: '100%',
        tableHeight: 500 + 'px',
        search: true,
        columnSorting: false,
        tableOverflow: true,
        columns: [
            {
                title: 'Created',
                type: 'text',
                width: '200px',
                readOnly: true,
            },
            {
                title: 'Expiration',
                type: 'string',
                width: '250px',
                readOnly: true,
            },
            {
                title: 'Author',
                type: 'text',
                width: '150px',
                readOnly: true,
            },
            {
                title: 'Resident Unit',
                type: 'text',
                width: '150px',
                readOnly: true,
            },
            {
                title: 'Resident Name',
                type: 'text',
                width: '150px',
                readOnly: true,
            },
            {
                title: 'Severity',
                type: 'text',
                width: '150px',
                readOnly: true,
            },
            {
                title: 'Text',
                type: 'text',
                width: '520px',
                readOnly: true,
            }
        ],
        onload: function (instance) {


            $($(instance).find('td[data-x="0"]')).each(function (i, obj) {
                var residentUnitValue = $(obj).text();

                if (residentUnitValue != null && residentUnitValue.length > 0 && i > 0) {

                    // $(obj).css("color", "#ccc");
                    // $(obj).css("font-weight", "bold");
                }
            });

            $($(instance).find('td[data-x="0"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            $($(instance).find('td[data-x="1"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            //$($(instance).find('td[data-x="2"]')).each(function (i, obj) {
            //    $(obj).css("background-color", "#ccc");
            //});




            $($(instance).find('.jexcel_filter')).each(function (i, obj) {
                $(obj).prepend($("#archive-announcements-title"));
            });
            $(".jexcel_search").css({ "border": "1px solid #ccc" });
            $(".jexcel_search").css({ "margin-top": "20px" });


        },
        onbeforechange: function (instance, cell, x, y, value) { },
        oneditionstart: function (instance, cell, x, y) {
        },
        onselection: function (instance, x1, y1, x2, y2, origin) {

            ////Used to jump to next column while marking the columnSeperator
            //if (x1 == 2) {
            //    archiveAnnouncementsTable.updateSelectionFromCoords(3, y1, 3, y2);
            //    console.log("selected" + x1 + y1 + x2 + y2);
            //}
        },
        onchange: function (obj, cel, val) { },
        rowResize: true
    });


        //notifications

        archiveNotificationsTable = jexcel(document.getElementById('notificationsarchivegrid'), {
            allowManualInsertColumn: false,
            allowInsertColumn: false,
            allowDeleteColumn: false,
            allowRenameColumn: false,
            columnDrag: false,
            data: null,
            tableWidth: '100%',
            tableHeight: 500 + 'px',
            search: true,
            columnSorting: false,
            tableOverflow: true,
            columns: [
                {
                    title: 'Mode',
                    type: 'text',
                    width: '100px',
                    readOnly: true,
                },
                {
                    title: 'Type',
                    type: 'string',
                    width: '50px',
                    readOnly: true,
                },
                {
                    title: 'Timestamp',
                    type: 'text',
                    width: '200px',
                    readOnly: true,
                },
                {
                    title: 'Status',
                    type: 'text',
                    width: '100px',
                    readOnly: true,
                },
                {
                    title: 'Unit',
                    type: 'text',
                    width: '200px',
                    readOnly: true,
                },
                {
                    title: 'Name',
                    type: 'text',
                    width: '150px',
                    readOnly: true,
                },
                {
                    title: 'Receiver',
                    type: 'text',
                    width: '150px',
                    readOnly: true,
                },
                {
                    title: 'Message',
                    type: 'text',
                    width: '600px',
                    readOnly: true,
                }
            ],
            onload: function (instance) {


                //$($(instance).find('td[data-x="0"]')).each(function (i, obj) {
                //    var residentUnitValue = $(obj).text();

                //    if (residentUnitValue != null && residentUnitValue.length > 0 && i > 0) {

                //        // $(obj).css("color", "#ccc");
                //        // $(obj).css("font-weight", "bold");
                //    }
                //});

                //$($(instance).find('td[data-x="0"]')).each(function (i, obj) {
                //    if (i == 0) {
                //        $(obj).css("font-weight", "bold");
                //    }
                //});

                //$($(instance).find('td[data-x="1"]')).each(function (i, obj) {
                //    if (i == 0) {
                //        $(obj).css("font-weight", "bold");
                //    }
                //});

                //$($(instance).find('td[data-x="2"]')).each(function (i, obj) {
                //    $(obj).css("background-color", "#ccc");
                //});




                $(".jexcel_search").css({ "border": "1px solid #ccc" });
                $(".jexcel_search").css({ "margin-top": "20px" });


            },
            onbeforechange: function (instance, cell, x, y, value) { },
            oneditionstart: function (instance, cell, x, y) {
            },
            onselection: function (instance, x1, y1, x2, y2, origin) {

                ////Used to jump to next column while marking the columnSeperator
                //if (x1 == 2) {
                //    archiveAnnouncementsTable.updateSelectionFromCoords(3, y1, 3, y2);
                //    console.log("selected" + x1 + y1 + x2 + y2);
                //}
            },
            onchange: function (obj, cel, val) { },
            rowResize: true
        });

});

    return 1;
}


function severityNameLookup(severity) {
    if (severity == 1) {
        return "Info";
    }
    else if (severity == 2) {
        return "Warning";
    }
    else if (severity == 3) {
        return "Emergency";
    }

    return "Info";
}


function PopulateAnnouncementArchiveTable(announcementsInDatabase, dateformat) {
    try {
        var announcements = [];

        console.log(announcementsInDatabase);

        announcementsInDatabase.forEach(announcement => announcements.push([
            dateformat ? timestampToUsDate(announcement.announcementCreated) : timestampToJexcelDate(announcement.announcementCreated),
            dateformat ? timestampToUsDate(announcement.announcementExpires) : timestampToJexcelDate(announcement.announcementExpires),
            announcement.announcementAuthor,
            announcement.announcementReceiverUnit,
            announcement.announcementReceiverName,
            severityNameLookup(announcement.announcementSeverity),
            announcement.announcementText]));

        if (archiveAnnouncementsTable != null) {
            archiveAnnouncementsTable.setData(announcements, false);
        } else {
        }
    } catch (e) {

        console.log("PopulateAnnouncementArchiveTable Error");
        console.log(e);

    }

    return 1;
}


function translateNotificationMode(notification) {
    if (notification != null) {
        if (notification.notificationBroadcast == 1) {
            return "Broadcast";
        }
        else if (notification.notificationManual == 1) {
            return "Manual";
        }
        else {
            return "Automatic";
        }
    }
}



function PopulateNotificationsArchiveTable(notificationsInDatabase, dateformat) {
    try {
        var notifications = [];

        console.log(notificationsInDatabase);

        notificationsInDatabase.forEach(notification => notifications.push([
            translateNotificationMode(notification),
            notification.notificationType == 0 ? "Text" : "Email",
            dateformat ? timestampToUsDate(notification.notificationTimestamp) : timestampToJexcelDate(notification.notificationTimestamp),
            notification.notificationStatus,
            notification.notificationReceiverUnit,
            notification.notificationReceiverName,
            notification.notificationPhoneNumber,
            notification.notificationText]));

        if (archiveNotificationsTable != null) {
            archiveNotificationsTable.setData(notifications, false);
        } else {
        }
    } catch (e) {

        console.log("PopulateAnnouncementArchiveTable Error");
        console.log(e);

    }

    return 1;
}
